export default {
  en: {
    order: 'Order',
    currentOrder: 'Current order',
    status: 'Status',
    reject: 'Decline',
    acceptOrder: 'Accept order',
    readyForPickup: 'Order ready',
    noActiveOrder: 'No active orders',
    selectOrderHint: 'Open an order from the Orders tab',
    errorLoadOrder: 'Could not load order',
    errorLoadOrders: 'Could not load orders',
    errorActionFailed: 'Action failed',
    preparationTimeTitle: 'Estimated preparation time',
    pickupReadyAt: 'Ready by',
    willBeReadyBy: 'Will be ready by',
    orderTitle: 'Order {id}',
    orderTotal: 'Order total',
    composition: 'Items',
    copyId: 'Copy order ID',
    copyIdSuccess: 'Order ID copied',
    copyIdFailed: 'Could not copy order ID',
    tabActive: 'Active',
    tabArchive: 'Archive',
    itemsForClient: '{count} items for ',
    orderAmount: 'order amount',
    deliveryFee: 'cash on delivery',
    createdAtShort: '{dayMonth} at {time}',
    paginationAria: 'Orders pagination',
    paginationNext: 'Next pages',
  },
  ru: {
    order: 'Заказ',
    currentOrder: 'Текущий заказ',
    status: 'Статус',
    reject: 'Отказ',
    acceptOrder: 'Принять заказ',
    readyForPickup: 'Заказ готов',
    noActiveOrder: 'Нет активных заказов',
    selectOrderHint: 'Выберите заказ во вкладке «Заказы»',
    errorLoadOrder: 'Не удалось загрузить заказ',
    errorLoadOrders: 'Не удалось загрузить заказы',
    errorActionFailed: 'Не удалось выполнить действие',
    preparationTimeTitle: 'Ориентировочное время приготовления',
    pickupReadyAt: 'Готово к',
    willBeReadyBy: 'Будет готов к',
    orderTitle: 'Заказ {id}',
    orderTotal: 'Сумма заказа',
    composition: 'Состав',
    copyId: 'Скопировать ID заказа',
    copyIdSuccess: 'ID заказа скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    tabActive: 'Активный',
    tabArchive: 'Архивный',
    itemsForClient: '{count} поз. для ',
    orderAmount: 'сумма заказа',
    deliveryFee: 'наложенный платеж',
    createdAtShort: '{dayMonth} в {time}',
    paginationAria: 'Пагинация заказов',
    paginationNext: 'Следующие страницы',
  },
}
